export default __webpack_public_path__ + "static/media/Logout.d3da1503.svg";